import type { IndicatorPulseColor } from '@shared/ui/indicators'
import type { TutorBillingRow } from './interfaces'
import type { TutorBillingIndicator } from './types'

import { TutorBillingModal } from './enums'
import { useTutorBillingStore } from './store'
import { getTutorBillingIndicator } from '../lib/tutor-billing-indicator'

interface TutorBillingIndicatorOptions {
  row: ComputedRef<TutorBillingRow>
}

interface TutorBillingIndicatorReturn {
  indicator: ComputedRef<TutorBillingIndicator>
  color: ComputedRef<IndicatorPulseColor>
  label: ComputedRef<string>
  setOpen: () => void
}

export const useTutorBillingIndicator = ({ row }: TutorBillingIndicatorOptions): TutorBillingIndicatorReturn => {
  const store = useTutorBillingStore()

  const indicator = computed<TutorBillingIndicator>(() => getTutorBillingIndicator(row.value))

  const isNewAccount = computed<boolean>(() => indicator.value === 'new-account')

  const color = computed<IndicatorPulseColor>(() => isNewAccount.value ? 'blue' : 'red')

  const label = computed<string>(() => isNewAccount.value ? 'New billing info submitted' : 'Billing info change requested')

  const setOpen = (): void => {
    store.openModal(isNewAccount.value ? TutorBillingModal.NewAccount : TutorBillingModal.ChangeRequest, row.value)
  }

  return {
    indicator,
    color,
    label,
    setOpen,
  }
}
